module.exports = __webpack_public_path__ + "static/media/avatar.5e0d8b9c.jpg";